import React from "react";
import { FaChevronLeft } from "react-icons/fa";
import Automation from "../JobPosting/automation";
import { useJobFlowTracking } from "../../hooks/useJobFlowTracking";

function Stage3SetAutomationRules({
  onNext,
  onBack,
  jobId,
  transitioning,
  transitionMessage,
  flowSessionId,
}) {
  const { trackComplete } = useJobFlowTracking({
    flowSessionId,
    stepId: 'set_automation_rules',
    stepLabel: 'Set Automation Rules',
    jobId,
  });
  if (transitioning) {
    return (
      <div className="cj-stage3" style={{ pointerEvents: "none",  }}>
        <div className="cj-stage-header">
          <div>
            <p className="gradient-text-loading">{transitionMessage}</p>
          </div>
        </div>
        <div className="gradient-border-wrap" style={{ width: "340px" }}>
          <div className="cj-feature-card-empty-skeleton" />
        </div>
      </div>
    );
  }
  return (
    <div className="cj-stage3">
      <div>
        <div className="cj-stage-header">
          <div>
            <button className="cj-back-link" onClick={onBack}>
              <FaChevronLeft /> Back to Set AI Features
            </button>
          </div>
          <div className="cj-mobile-sticky-bar">
            <button className="cj-btn-primary" onClick={() => { trackComplete(jobId); onNext(); }}>
              Next: Invite candidates <span className="cj-btn-arrow">→</span>
            </button>
          </div>
        </div>
        <div>
          <h3 className="cj-stage-title">Configure Workflow Rules</h3>
            <p className="cj-stage-subtitle">
              Set thresholds and triggers for your selected screening methods to
              automate your hiring pipeline.
            </p>
        </div>
      </div>

      <Automation jobId={jobId} />
    </div>
  );
}

export default Stage3SetAutomationRules;
